import { useEffect, useState } from 'react';

import { LI } from '../../../AbstractElements';
import { Href } from '../../../Utils/Constants';
import { SvgIcon } from '../../../components/common/Icon/SvgIcon';

export default function MoonLight() {
   const [darkMode, setDarkMode] = useState<boolean>(() => {
      const storedValue = localStorage.getItem('darkMode');
      return storedValue ? JSON.parse(storedValue) : false;
   });

   const darkModeHandler = () => {
      const newMode = !darkMode;

      if (newMode) {
         document.body.classList.remove('light');
         document.body.classList.add('dark-only');
      } else {
         document.body.classList.remove('dark-only');
         document.body.classList.add('light');
      }

      setDarkMode(newMode);
      localStorage.setItem('darkMode', JSON.stringify(newMode));
   };

   useEffect(() => {
      if (darkMode) {
         document.body.classList.add('dark-only');
         document.body.classList.remove('light');
      } else {
         document.body.classList.add('light');
         document.body.classList.remove('dark-only');
      }
   }, [darkMode]);

   return (
      <LI>
         <a
            className={`dark-mode ${darkMode ? 'active' : ''}`}
            onClick={darkModeHandler}
            href={Href}
         >
            <SvgIcon iconId={darkMode ? 'sunny' : 'moon'} />
         </a>
      </LI>
   );
}
